module.exports = __webpack_public_path__ + "img/boky_08_oranzova.f07ff333.png";